import {
  ChannelType,
  ConversionStageReachedType,
  DeviceType,
  VisitorType,
} from "@intelligems/ig-types";

export const deviceTypeList: { label: string; key: DeviceType }[] = [
  {
    label: "All Devices",
    key: "any",
  },
  {
    label: "Desktop",
    key: "desktop",
  },
  {
    label: "Mobile",
    key: "mobile",
  },
];

export const conversionStageReachedList: {
  label: string;
  key: ConversionStageReachedType;
}[] = [
  {
    label: "All Stages",
    key: "any",
  },
  {
    label: "Added to Cart",
    key: "added_to_cart",
  },
  {
    label: "Started Checkout",
    key: "started",
  },
  {
    label: "Contact Info Submitted",
    key: "contact_info_submitted",
  },
  {
    label: "Address Info Submitted",
    key: "address_info_submitted",
  },
];

export const visitorTypeList: {
  label: string;
  key: VisitorType | undefined;
}[] = [
  {
    label: "All Visitors",
    key: "any",
  },
  {
    label: "New",
    key: "new",
  },
  {
    label: "Returning",
    key: "returning",
  },
];

export const trafficSourceList: { label: string; key: ChannelType }[] = [
  {
    label: "Google",
    key: "Google",
  },
  {
    label: "Facebook",
    key: "Facebook",
  },
  {
    label: "Instagram",
    key: "Instagram",
  },
  {
    label: "TikTok",
    key: "TikTok",
  },
  {
    label: "Twitter",
    key: "Twitter",
  },
  {
    label: "YouTube",
    key: "Youtube",
  },
];
export const newChannelList: { label: string; key: ChannelType }[] = [
  {
    label: "Direct",
    key: "Direct",
  },
  {
    label: "Email",
    key: "Email",
  },
  {
    label: "Referral",
    key: "Referral",
  },
  {
    label: "Organic Social",
    key: "Organic Social",
  },
  {
    label: "Paid Social",
    key: "Paid Social",
  },
  {
    label: "Organic Search",
    key: "Organic Search",
  },
  {
    label: "Paid Search",
    key: "Paid Search",
  },
  {
    label: "SMS",
    key: "SMS",
  },
];

export const channelTypeList: { label: string; key: ChannelType | null }[] = [
  {
    label: "All Sources",
    key: null,
  },
  ...newChannelList,
  ...trafficSourceList,
];
